import { setToken } from '../utils/authUtils';
import { appendQueryParamsToUrl } from '../utils';
import api from './index';

const BASE = '/working-unit-location';

export const getWorkingUnitLocations = async ({
    location,
    hasMatchingOfferedCluster,
    dateFrom,
    dateTo,
    includeLatestDataMonth,
    includeCorrectedTotalsInfo,
    releasedOnly,
} = {}) => {
    let url = `${BASE}`;
    url = appendQueryParamsToUrl(url, {
        location,
        hasMatchingOfferedCluster,
        dateFrom,
        dateTo,
        includeLatestDataMonth,
        includeCorrectedTotalsInfo,
        releasedOnly,
    });

    return api.get(url, await setToken()).then((res) => res.data);
};

// Async enrichment for the selector: per-WUL latest-data / corrected-totals "through" months.
// Fetched separately from the base list so the heavy aggregations don't block the dropdown.
export const getWorkingUnitLocationMetadata = async ({ location, hasMatchingOfferedCluster, releasedOnly } = {}) => {
    let url = `${BASE}/metadata`;
    url = appendQueryParamsToUrl(url, { location, hasMatchingOfferedCluster, releasedOnly });

    return api.get(url, await setToken()).then((res) => res.data);
};
